<template lang="pug">
.container(id="Login-container")
  .background-container(id="Login-backgroundContainer", :style="{ backgroundImage: 'url(/static/bg/' + currentPhoto.file + ')' }")
  .page-container(id="Login-pageContainer")
    .login(id="Login-loginContainer")
    .login-box(id="Login-loginBox")
      p.alert(v-if='viewportToSmall', id="Login-windowTooSmallAlert") {{$t('Your browser window is too small. You may experience inconvenience using WAVE2.')}}
      p.alert(v-if='viewportToSmall', id="Login-minResolutionInfo") {{$t('Minimum recommended resolution is 1768 x 852.')}}
      p.alert(v-if='viewportToSmall', id="Login-userResolutionInfo") {{$t('Your resolution is ')}} {{ innerWidthValue }} x {{ innerHeightValue}}
      .logo(id="Login-logo")
      .logo-description(id="Login-logoText") Multimedia everywhere
      .warning(v-if='loginError')
        h4(id="Login-errorOccuredWarning") {{ $t('An error occured:')}}
        h5(id="Login-errorOccuredContent") {{ loginError }}
      .warning(v-if='$v.email.$error && $v.email.required')
        h4(id="Login-wrongEmailFormatWarning") {{ $t('Wrong email format') }}
      .warning(v-if='$v.email.$error && !$v.email.required')
        h4(id="Login-emailRequiredWarning") {{ $t('Enter login email.') }}
      .warning(v-if='$v.password.$error && !$v.password.required')
        h4(id="Login-passwordRequiredWarning") {{ $t('Enter password.') }}
      .warning(v-if='$v.password.$error && !$v.password.minLength')
        h4(id="Login-passwordMinLengthWarning") {{ $t('Minimum password length is 4 characters.') }}
      el-form(id="Login-loginForm" ref="loginForm", @submit.native.prevent="submitForm()")
        .form-item(:class="{'is-error': $v.email.$error}")
          input(type="text" id="Login-loginForm-emailInput" v-model.trim.lazy="$v.email.$model" :placeholder="$t('Email address')", class="email-input", @change='clearLoginError()')
        .form-item(:class="{'is-error': $v.password.$error}")
          input(type="password" id="Login-loginForm-passwordInput" v-model.trim.lazy="$v.password.$model" :placeholder="$t('Password')", @change='clearLoginError()')
        .form-item.warning(v-if='!version')
          p(id="Login-loginForm-connectingToServer-warning") {{ $t('connecting to server...') }}
        .form-item.submit-button(v-else)
          button(id="Login-loginForm-submitButton") {{ loading ? $t('Logging in...') : $t('Login') }}
      .sso-selector(v-if="providers.length > 0")
        .ruler
          hr(id="Login-ruler")
        p {{ $t('Or continue with:') }}
        a.sso-provider(v-for="provider in providers", :href="`/user/login/${provider.id}`")
          .image
            img(:src='getProviderImg(provider)' )
          .name &nbsp; {{ provider.name.toUpperCase() }}
      .ruler
        hr(id="Login-ruler2")
      .copy-info
        a(id="Login-copyrightInfo" href='https://m4b.pl', target='_blank') Copyright &copy; 2020-{{ new Date().getFullYear() }} M4B S.A. v{{ version }}
      .foto-credit
        span(id="Login-photoCredit") {{ currentPhoto.credit }}
      .userNotRegisted-box(v-if="isUserAuthenticated && !userHasClient")
        el-form(id="Login-userNotRegisteredForm" ref="networkForm" size="small")
        el-form-item
          el-header(id="Login-userNotActivatedText") User not activated
      .forgot-password
        el-button(id="Login-recoverPasswordButton" type='text', @click='loadRecoverPasswordForm')
          p(id="Login-recoverPasswordText") {{ $t('Forgot your password?')}}
</template>

<script>
import Vue from 'vue'
import { required, email, minLength } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
      innerWidth: undefined,
      innerHeight: undefined,
      picked: undefined,
      email: '',
      password: '',
      overdueWs: true,
      pingApiInterval: null,
      loadedTime: undefined,
      version: '',
      providers: [],
      loginError: undefined,
      currentPhoto: {},
      loading: false,
      photos: [
        {
          file: 'cassie-matias--lpbnspYkJg-unsplash.jpg',
          credit: 'Photo by Cassie Matias on Unsplash'
        },
        {
          file: 'ines-alvarez-fdez-u6rZ2_bUgUE-unsplash.jpg',
          credit: 'Photo by Ines Alvarez on Unsplash'
        },
        {
          file: 'james-pritchett-cqdl_0gQY1M-unsplash.jpg',
          credit: 'Photo by James Pritchett on Unsplash'
        },
        {
          file: 'jeremy-bishop-llkPqjQTeok-unsplash.jpg',
          credit: 'Photo by Jeremy Bishop on Unsplash'
        },
        {
          file: 'jeremy-bishop-uBHSWYWZT7A-unsplash.jpg',
          credit: 'Photo by Jeremy Bishop on Unsplash'
        },
        {
          file: 'lance-asper-n3cVKwAugtc-unsplash.jpg',
          credit: 'Photo by Lance Asper on Unsplash'
        },
        {
          file: 'antonio-pina-IbjSKhO1xXI-unsplash.jpg',
          credit: 'Photo by Antonio Pina on Unsplash'
        },
        {
          file: 'atte-gronlund-zS2iq9zU3sc-unsplash.jpg',
          credit: 'Photo by Atte Gronlund on Unsplash'
        },
        {
          file: 'carl-j-jcSiJ3JQ5QY-unsplash.jpg',
          credit: 'Photo by Carl J on Unsplash'
        },
        {
          file: 'chris-grafton-dLhGAvFdmcc-unsplash.jpg',
          credit: 'Photo by Chris Grafton on Unsplash'
        },
        {
          file: 'george-desipris-svEN_5NXO3o-unsplash.jpg',
          credit: 'Photo by George Desipris on Unsplash'
        },
        {
          file: 'george-desipris-sXzuRmorw7o-unsplash.jpg',
          credit: 'Photo by George Desipris on Unsplash'
        },
        {
          file: 'james-peacock-BDATv21bg9M-unsplash.jpg',
          credit: 'Photo by James Peacock on Unsplash'
        },
        {
          file: 'james-peacock-vOWaLcUCJIM-unsplash.jpg',
          credit: 'Photo by James Peacock on Unsplash'
        },
        {
          file: 'ludomil-lsXbZtrVSdQ-unsplash.jpg',
          credit: 'Photo by Ludomil on Unsplash'
        },
        {
          file: 'marcus-dall-col-5rh8fzL0hI8-unsplash.jpg',
          credit: 'Photo by Marcus Dall Col on Unsplash'
        }
      ]
    }
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(4)
    }
  },
  beforeCreate () {
    if (this.$route.fullPath === '/login' && localStorage.providerLogin) {
      this.$router.push({ path: localStorage.providerLogin })
    }
  },
  async created () {
    this.version = await this.$store.dispatch('User/getPackageVersion')
    this.providers = (await this.$store.dispatch('User/getAuthProviders')).filter(prov => prov.strategy !== 'passport-local')
    if (this.$route.query.error) {
      this.loginError = this.$route.query.error
    }
    if (this.$route.query.provider) {
      localStorage.providerLogin = this.$route.fullPath
      this.providers = [this.providers.find(p => p.name === this.$route.query.provider)]
    } else {
      this.providers = this.providers.filter(p => !p.hidden)
    }
    clearInterval(this.pingApiInterval)
    this.pingApiInterval = setInterval(async () => {
      this.version = await this.$store.dispatch('User/getPackageVersion')
    }, 10 * 1000)
  },
  beforeDestroy () {
    clearInterval(this.pingApiInterval)
  },
  methods: {
    getProviderImg (provider) {
      const supportedIcons = ['m4b', 'keycloak', 'generic', 'amrest']

      return '/static/auth/' + (supportedIcons.includes(provider.id) ? provider.id : 'generic') + '.png'
    },
    clearLoginError () {
      this.loginError = undefined
    },
    __formatLoginError (error) {
      if (!error) return
      if (error.response) {
        if (error.response.status === 401) {
          return `${this.$t('Wrong creditientials.')} ${this.$t('Check email and password and try again.')}`
        }
        if (error.response.status === 403) {
          return `${this.$t('Your account / network is blocked. Please contact administrator.')}`
        }
        return `
          ${error.response.status ? error.response.status : 'no status code'}
           -
          ${error.response.statusText ? error.response.statusText : 'no status text'}
          `
      }
      return `Unknown error occured. ${error.toString()}`
    },
    loadRecoverPasswordForm () {
      this.$router.push({ path: '/recoverpassword/forgotten' })
    },
    debug (network, userlastnetwork) {
      if (network.id === userlastnetwork) {
        console.log('equal')
        return true
      }
      console.log('not equal')
      return false
    },
    submitForm () {
      this.$store.commit('User/SET_CHANGING_NETWORK_STATUS_DEVICES', 'Loading devices...', { root: true })
      // if (!this.$store.state.Error.ws_status.status === 200) return
      this.loading = true
      this.loginError = undefined
      this.$v.$touch()
      if (!this.$v.$invalid) {
        Vue.axios.post('user/login', {
          email: this.email,
          password: this.password
        })
          .then(async response => {
            await this.$store.dispatch('Error/deleteAxiosError', {}, { root: true })
            await this.$store.commit('User/RESET_USER', {}, { root: true })
            await this.$store.dispatch('Device/clearList', {}, { root: true })
            await this.$store.dispatch('Medium/clearList', {}, { root: true })
            await this.$store.dispatch('File/clearList', {}, { root: true })
            await this.$store.dispatch('User/loginSuccessful', response.data)
            if (this.$route.query.next) {
              window.location = this.$route.query.next
            } else {
              this.$router.push({ path: '/layout-router/' })
            }
            this.loading = false
          })
          .catch(error => {
            if (error.response && error.response.data === 'PASSWORD_EXPIRED') {
              return this.$router.push({ path: '/recoverpassword/expired' })
            }
            if (error.response && error.response.data === 'FIRST_LOGIN') {
              return this.$router.push({ path: '/recoverpassword/not_activated' })
            }
            this.loginError = this.__formatLoginError(error)
            this.loading = false
          })
      }
    }
  },
  beforeMount () {
    this.currentPhoto = this.photos[Math.floor(Math.random() * this.photos.length)]
  },
  computed: {
    innerWidthValue () {
      return window.innerWidth
    },
    innerHeightValue () {
      return window.innerHeight
    },
    viewportToSmall () {
      return window.innerWidth < 1768 || window.innerHeight < 852
    },
    isUserAuthenticated: {
      get () {
        return this.$store.state.User.user.id
      }
    },
    userHasClient: {
      get () {
        return this.$store.state.User.user.Client
      }
    },
    userlastnetwork: {
      get () {
        return this.$store.state.User.user.lastNetworkId
      }
    },
    pickedNetwork: {
      get () {
        return this.picked
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.alert {
  color: $--color-warning;
}
.background-container, .page-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
}
.background-container {
  filter: blur(10px);
  -webkit-filter: blur(10px);
  margin: -10px;
}
.page-container {
  display: flex;
  align-items: center;
  justify-content: right;
  border: 0px dotted red;
  background: rgba($--color-primary-light-9, .7);
  .login-box {
    border: 0px dotted green;
    width: 400px;
    background: transparent;
    padding: 0px;
    margin: 0 auto;
    text-align: center;
    .logo {
      height: 70px;
      border: 0px dotted red;
      opacity: 1.0;
      width: 100%;
      background: url('/static/wave2-logo.svg') 100% no-repeat;
      background-size: contain;
      margin: 0 auto;
    }
    .logo-description {
      border: 0px dotted red;
      text-align: right;
      color: $--color-text-secondary;
      font-size: 21px;
      padding-bottom: 10px;
    }
    .el-form {
      display: flex;
      align-items: center;
      width: 100%;
      flex-direction: column;
      .el-alert--error {
        background: rgba($--color-primary-light-9, 0);
      }
      .form-item {
        border: 0px dotted blue;
        padding-bottom: 0px;
        width: 100%;
        background-color: rgba($--color-black, 0.12);
        border-radius: 4px;
        margin: 0px 0px 20px 0px;
        height: 40px;
        input {
          height: 40px;
          width: 100%;
          font-size: 17px;
          background: rgba(0, 0, 0, 0);
          border: none;
          outline: none;
          color: $--color-black;
          padding-left: 7px;
          border-radius: 4px;
        }
        &.submit-button {
          background-color: rgba($--color-black, 0.4);
          display: flex;
          button {
            border: 0px dotted blue;
            width: 100%;
            font-size: 17px;
            background: rgba(0, 0, 0, 0);
            border-radius: 4px;
            cursor: pointer;
            color:white;
            font-weight: bold;
          }
        }
      }
      .svg-inline--fa {
        margin-right: 10px;
      }
    }
    .ruler {
      opacity: 0.3;
    }
    .copy-info {
        opacity: 0.4;
      a {
        color: $--color-text-regular;
        // color: $--color-text-secondary;
        text-decoration: none;
        font-size: 12px;
      }
    }
    .ruler {
      margin-top: -10px;
    }
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: #fff !important;
  }
  .foto-credit {
    z-index: 10000000;
    position: fixed;
    bottom: 3px;
    right: 3px;
    color: rgba($--color-text-regular, 0.5);
    border: 0px dotted green;
    opacity: 1;
  }
  .sso-selector {
    margin-bottom: 2em;
  }
  .sso-provider {
    display: flex;
    // justify-content: center;
    background-color: rgba($--color-black, 0.12);
    border-radius: 3px;
    margin-bottom: 1em;
      padding: 10px;
      color: white;
      text-decoration: none;
      display: flex;
      align-items: center;
      .image {
        width: 6em;
        height: 2.5em;
        display: flex;
        justify-content: center;
        margin-left: 120px;
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/Login.vue